
import React from 'react';

export function CountryFlagScreen(props: { country: string | undefined, style?: React.CSSProperties }) {
    const country = props.country?.toLowerCase();
    return <>
        {country && <img className="flag" width="40px" style={props.style ?? { marginTop: '-10px', marginRight: '5px' }} src={`img/flags/1x1/${country}.svg`} alt={country} />}
    </>
}